
import { Document, ProjectRegistryData } from '@wren/shared/src/lib/isometric';
import { useState } from 'react';
import { articleStyles, container } from '../../../style/article';
import { scale } from '../../../util/scale';
import Button from '../../buttons/Button';
import DownloadableDocumentLink from '../DownloadableDocumentLink';

const fadeStyle = (rgb: string) =>
  scale({
    position: 'absolute',
    zIndex: 2,
    background: [
      `linear-gradient(rgba(${rgb},0) 0%, rgba(${rgb},1) 70%, rgba(${rgb},1) 100%)`,
      `linear-gradient(rgba(${rgb},0) 0%, rgba(${rgb},1) 60%, rgba(${rgb},1) 100%)`,
    ],
    height: 'calc(80% + 8px)',
    width: 'calc(100% + 8px)', // add a bit extra width
    left: -4, // extra width accomodates box shadow on white card style
    bottom: -8,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  });

export default function ProjectDocumentation({
  registryData,
}: {
  registryData: ProjectRegistryData;
}) {
  if (!registryData?.documents?.length || !registryData?.url) {
    return null;
  }

  const documents = registryData.documents?.sort((a, b) =>
    a.id.localeCompare(b.id)
  );
  const [showMoreUpdates, setShowMoreUpdates] = useState(false);

  return (
    <div>
      {registryData.url && (
        <>
          <div css={articleStyles}>
            <h3 id="project-documentation">Project documentation</h3>
            <p>
              These documents are provided by{' '}
              <a
                href={registryData.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {registryData.registry}
              </a>
              , the registry that helps ensure the accuracy and reliability of
              the information presented by this project.
            </p>
          </div>
          <div css={container}>
            <div css={{ position: 'relative', marginTop: 24 }}>
              {documents.length < 6 || showMoreUpdates ? (
                <>
                  <div>
                    {documents?.map((document: Document) => {
                      return (
                        <DownloadableDocumentLink
                          key={document.id}
                          title={document.title}
                          href={document.url}
                          type={
                            document.url.split('.').pop()?.toUpperCase() ||
                            'WEB'
                          }
                        />
                      );
                    })}
                  </div>
                  <div css={{ width: 200, margin: 'auto', marginTop: 36 }}>
                    <Button
                      size="medium"
                      type="grayUppercase"
                      text="Show less"
                      onClickFn={() => setShowMoreUpdates(!showMoreUpdates)}
                    />
                  </div>
                </>
              ) : (
                <>
                  {documents?.slice(0, 5).map((document: Document) => {
                    return (
                      <DownloadableDocumentLink
                        key={document.id}
                        title={document.title}
                        href={document.url}
                        type={
                          document.url.split('.').pop()?.toUpperCase() || 'WEB'
                        }
                      />
                    );
                  })}
                  <div css={fadeStyle('255, 255, 255')}>
                    <div css={{ width: 200, marginBottom: 36 }}>
                      <Button
                        size="medium"
                        type="grayUppercase"
                        text="Show more"
                        onClickFn={() => setShowMoreUpdates(!showMoreUpdates)}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
